
$(function(){
  const jqueryProductsScriptTag = document.createElement('script');
  jqueryProductsScriptTag.src = window.theme.jqueryProductJSFileSrc;
  jqueryProductsScriptTag.async = true;
  jqueryProductsScriptTag.onload = function(e){
    Shopify.Products.recordRecentlyViewed();
    Shopify.Products.showRecentlyViewed({
      howManyToShow: 6,
      onComplete: function(){
        if($('#recently-viewed-products .product-item').length > 0) {
          $('.recently-viewed').addClass('active');
          $('#recently-viewed-products').slick({
            autoplay: true,
            speed: 1000,
            slidesToShow: 4,
            pauseOnHover: false,
            slidesToScroll: 4,
            prevArrow: '<i class="lnr lnr-chevron-left left-arrow animation"></i>',
            nextArrow: '<i class="lnr lnr-chevron-right right-arrow animation"></i>',
            responsive: [
              {
                breakpoint: 584,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                }
              },
              {
                breakpoint: 900,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                }
              }
            ]
          });
        }
      }
    });
  };
  document.head.appendChild(jqueryProductsScriptTag);
});